/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Arvind Krishnamurthy",
  title: "Hi there, this is Arvind",
  subTitle: emoji(
    "A passionate Full Stack Software Developer having an experience of designing and building Web applications with Reactjs/ JavaScript/ .Net Core and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1HcA0-lnJ4Py7hHD3GoYzV34OUiHxMjqi/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/-arvind-krishnamurthy",
  gmail: "arvind.softwaredev@gmail.com",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end for web applications using React JS"
    ),
    emoji("⚡ Competent in building ASP.Net Core back-end structure"),
    emoji(
      "⚡ ElasticSearch and Sql for data management"
    )
  ],

  softwareSkills: [
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React JS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: ".Net Core",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "Node JS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Elastic Search",
      fontAwesomeClassname: "fab fa-etsy"
    },
    {
      skillName: "Kibana",
      fontAwesomeClassname: "fab fa-korvue"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "FireBase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "GIT",
      fontAwesomeClassname: "fab fa-git-square"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc:
        "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend / Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    },
    {
      Stack: "Learning new techs",
      progressPercentage: "100%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Software Developer",
      company: "Deloitte",
      companylogo: require("./assets/images/deloitte_logo.jfif"),
      date: "November 2023 – Present",
      descBullets: [
        "Developing a Report analysis system, providing Insights like Peer analysis, benchmark data, for the Auditors.",
        "Involved in building an interface using React JS to view company reports with keyword search and tagging functionality by performing text recognition on pdfs stored in Azure Blobs.",
        "Building an Automation Test Suite by leveraging LLMs and GenAI using Python",
      ]
    },
     {
      role: "Software Developer II",
      company: "Honeywell",
      companylogo: require("./assets/images/honeywell-logo.png"),
      date: "October 2021 – October 2023",
      descBullets: [
        "Working in a Cloud based Building security system providing Video, Access and Intrusion features",
        "Involved in implementing cloud based video streaming of security camera",
        "Developing new features and enhancement of existing functionality",
        "Involved in peer code reviews, onboarding and training junior resources to the team"
      ]
    },
    {
      role: "Software Developer",
      company: "Arcadix",
      companylogo: require("./assets/images/arcadix-logo.png"),
      date: "November 2019 – September 2021",
      descBullets: [
        "Upskilled to React front-end library",
        "Implementing responsive end to end modules for an educational web application used to measure competencies",
        "Competent in building ASP.Net Core back-end structure",
        "Involved in migrating the project into Azure DevOps"
      ]
    },
    {
      role: "Associate Software Developer",
      company: "Accenture",
      companylogo: require("./assets/images/accenture-logo.png"),
      date: "August 2018 – November 2019",
      descBullets: [
        "Worked as dot net developer in a financial project",
        "Trained in ASP .NET and basics of JAVA, SQL"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "drakosi99", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Few projects I've worked on to explore and enchance my skill set",
  projects: [
    {
      image: require("./assets/images/netflix_logo.jfif"),
      projectName: "Netflix Clone",
      projectDesc: "Designed a front end clone of Netflix website to using React library and deployed in Firebase with a super responsive UI and basic functionalities.",
      footerLink: [
        // {
        //   name: "Visit Website",
        //   url: "fa"
        // }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/spotify_logo.png"),
      projectName: "Spotify Music Player",
      projectDesc: "Created a music player replica of Spotify with having front end part built using React and Spotify API for authentication and real time playing of songs from our own curated playlists.",
      footerLink: [
        // {
        //   name: "Visit Website",
        //   url: ""
        // }
      ]
    },
    {
      image: require("./assets/images/calorieTracker_logo.png"),
      projectName: "Calorie Tracker",
      projectDesc: "Web application developed using JavaScript that calculates the calories of your foods, designed with the Module Design Pattern and storage items in local storage.",
      footerLink: [
        // {
        //   name: "Visit Website",
        //   url: ""
        // }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url:
            ""
        },
        {
          name: "Award Letter",
          url:
            ""
        },
        {
          name: "Google Code-in Blog",
          url:
            ""
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url:
            ""
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to know more about me or just to say hi? My Inbox is open for all.",
  number: "(+91) 9791497664",
  email_address: "arvind.softwaredev@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "davidrakosi_", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
